import { Autenticado } from './autenticado';
import { Captcha } from './captcha';
import { ConfiguracaoVisual } from './configuracaoVisual';
import { Parceiro } from './parceiro';

export class Sessao {

    autenticado: Autenticado;
    configuracaoVisual: ConfiguracaoVisual;
    logado: boolean;
    cor: string;
    keyRecaptcha: string;
    captcha: Captcha;

    constructor() {
        this.autenticado = new Autenticado();
        this.autenticado.parceiro = new Parceiro();
        this.configuracaoVisual = new ConfiguracaoVisual();
    }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/sessao.ts